import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { rem } from 'design-system/values';
import useAppFrameDimensions from './useAppFrameDimensions';
const headerHeight = rem(100);
const paddingTop = rem(24);
export const useScrollableModalMaxHeight = (extraOffset = 0) => {
    const { height } = useAppFrameDimensions();
    const { top, bottom } = useSafeAreaInsets();
    return (height -
        (top || rem(24)) -
        (bottom || rem(24)) -
        headerHeight -
        paddingTop -
        extraOffset);
};
